var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"legal-notes"},[_c('h2',[_vm._v("Notas Legais Cookies")]),_c('p',[_vm._v("Aqui irão as informações sobre cookies :)")])])}
var staticRenderFns = []

export { render, staticRenderFns }